import React, { useEffect, useState } from "react";
// import Globals from '../../utility/constants/appConstants';
import Globals from "../../json/fallbackglobalvariables.json";

export default function MissionStatusChecker() {
    const { missionDownErrorDisplay } = Globals.acc;

    return (
                <div className="top-strip tg-plansandservice-bg" style={{minHeight: '38.5px'}} id='missionNotice'>
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <p id="myBtn" className='text-red'><img src="/images/error-notification-icon.png" className="mr-10" alt="mission" width={30} height={25} />{missionDownErrorDisplay}</p>
                    </div>
                  </div>
                </div>
              </div>
    );
}
